import { Component, OnInit, Input, OnChanges, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../components/common/utils/handleError.component';
import { SessionStorageService } from "ngx-webstorage";
import { ClienteLogin, ClienteXCiudad, Cliente } from '../login/cliente_login';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { fail } from 'assert';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';
import { LocalData } from 'ng2-completer/services/local-data';
import { UtilService } from '../../components/common/utils/util.service';
import { ConsultaCarpeta, Carpeta, Archivo, CarpetasArchivo, BuscaArchivos, Preguntas, Contacto } from '../../components/common/utils/entities/util_entity';
import { MasivosVHComponentService } from "./MasivosVH.service";
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Subscription } from 'rxjs/Subscription'; //<== added this
import { ClientePersonaEmpresa, DatosVeh } from '../register/entities/usuario_registro_entity';


const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
    selector: 'Arquetipo',
    templateUrl: 'MasivosVH.template.html'
})
@Injectable()
export class MasivosVHComponent implements OnInit {    
    vehCod: number;
    ciucod: number;
    unicod: number;
    showLoader: string;
    PINIngreso: string;
    usuario: ClientePersonaEmpresa;
    show = false;
    habilitar=true;
    vehiculo:DatosVeh;
    private subscription: Subscription = new Subscription();
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        private arquetipoService: MasivosVHComponentService,
        public utilsService: UtilService,
        public sesionStorageService: SessionStorageService,
        private completerService: CompleterService
    ) {      

        this.usuario = new ClientePersonaEmpresa();
        this.vehiculo = new DatosVeh();
    }
    ngOnInit(): void {
        
        this.vehiculo = new DatosVeh();
        this.showLoader = "sk-loading";
         this.PINIngreso="";
        this.route.params.subscribe(params => {
            this.vehCod=params['vehcod'];
            this.ciucod=params['ciudad'];
            this.unicod=params['unidad'];
            if (this.vehCod != null && this.ciucod != null && this.unicod != null) {

               this.arquetipoService.CosultaInformacion(this.vehCod,this.ciucod,this.unicod).subscribe(
                        rst => {
                           
                            if(rst.Error!=0)
                            {
                               
                                this.usuario = rst;
                                this.vehiculo =this.usuario.datovh;
                                //console.log(this.usuario )
                                //console.log(this.usuario.datovh)
                               // console.log(this.vehiculo)
                                    this.habilitar=false;
                            }
                            else
                            {
                                swal({
                                    title: 'Tecniseguros',
                                    text: "Lo sentimos,ya se encuentra realizado este proceso.",
                                    type: 'warning'
                                }).then((function(){
                                    window.location.href = "http://www.tecniseguros.com.ec"
                                }).bind(this));
                            }
                            this.showLoader = "";
                        },
                        error => {
                            swal({
                                title: 'Error',
                                text: "Lo sentimos hubo un error, por favor intente nuevamente",
                                type: 'error'
                            }).then((function(){
                                window.location.href = "http://www.tecniseguros.com.ec"
                            }).bind(this));
                            this.showLoader = "";
                        });
               
            }
        });
        

       
       
    }
    ngOnDestroy(){ //<== added this
        this.subscription.unsubscribe();
    }

    GenerarToken() {
        
        this.arquetipoService.GenerarToken(this.usuario).subscribe(
            result => {
                console.log(result);
                if(result!=undefined){
                    this.usuario=result;
                    swal({
                        title: 'Tecniseguros',
                        text: "Se ha enviado un correo y sms con el código de seguridad, por favor ingrese para seguir con el proceso.",
                        type: 'success'
                    }).then((function(){
                        //window.location.href = "http://www.tecniseguros.com.ec"
                    }).bind(this));
                }
                
                this.showLoader = "";
            },
            error => {
                swal({
                    title: 'Error',
                    text: "Lo sentimos hubo un error, por favor intente nuevamente",
                    type: 'error'
                }).then((function(){
                    window.location.href = "http://www.tecniseguros.com.ec"
                }).bind(this));
                this.showLoader = "";
            });

    }
    toggleShow(e: any, campo: number) {
        if (campo == 1) {
            this.show = !this.show;

        }
    }
    generarCartaAutorizacion() {
       // e.preventDefault();
       this.usuario.PinToken=Number(this.PINIngreso);
        this.arquetipoService.generarCartaAutorizacion(this.usuario).subscribe(result => {
            console.log(result);
            let fileBlob = result.blob();
            let blob = new Blob([fileBlob], {
                type: 'application/pdf'
            });

            var a = document.createElement("a");

            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "certificado" + ".pdf";
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, "certificado" + ".pdf");
            }
            else {
                a.click();
                window.URL.revokeObjectURL(url);
            }

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob);
            }
            else {
                var fileURL = URL.createObjectURL(blob);
                window.open(fileURL);
            }
            /*let fileBlob = result.blob();
            let blob = new Blob([fileBlob], {
                type: 'application/pdf'must match the Accept type
            });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob);
            }
            else {
                var fileURL = URL.createObjectURL(blob);
                window.open(fileURL);
            }*/
            swal({
                title: 'Tecniseguros',
                text: "Se ha enviado y generado correctamente la aprobación.",
                type: 'success'
            }).then((function(){
                window.location.href = "http://www.tecniseguros.com.ec"
            }).bind(this));
        }, error => { swal({
            title: 'Error',
            text: "Lo sentimos código incorrecto, ingrese nuevamente o generelo otra vez",
            type: 'error'
        }).then((function(){
        }).bind(this));
        this.showLoader = ""; });
    }

    
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/MasivoContratacion/MasivosVH.component.ts